// Typelizer digest 273ae274fad471b3739f99ac3eb726df
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /wait_lists/new_for_student */
  newForStudent: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/wait_lists/new_for_student', {}, options),
    method: 'get',
  }),

  /** POST /wait_lists/create_for_student */
  createForStudent: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/wait_lists/create_for_student', {}, options),
    method: 'post',
  }),

  /** GET /wait_lists/:id/cancel_for_student */
  cancelForStudent: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/wait_lists/:id/cancel_for_student', params, options),
    method: 'get',
  }),

  /** POST /wait_lists/:id/promote */
  promote: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/wait_lists/:id/promote', params, options),
    method: 'post',
  }),

  /** GET /wait_lists */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/wait_lists', {}, options),
    method: 'get',
  }),

  /** POST /wait_lists */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/wait_lists', {}, options),
    method: 'post',
  }),

  /** GET /wait_lists/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/wait_lists/new', {}, options),
    method: 'get',
  }),

  /** GET /wait_lists/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/wait_lists/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /wait_lists/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/wait_lists/:id', params, options),
    method: 'get',
  }),

  /** PATCH /wait_lists/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/wait_lists/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /wait_lists/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/wait_lists/:id', params, options),
    method: 'delete',
  }),
}
